import React from "react";
import { newsImageUrl } from "../../api/news";

/**
 * Рендер блочного контента статьи (content_blocks).
 * Типы: paragraph | heading | list | quote | image.
 */
export default function NewsContent({ blocks }) {
  if (!Array.isArray(blocks)) return null;
  return (
    <div className="nws-content">
      {blocks.map((b, i) => {
        switch (b.type) {
          case "paragraph":
            return <p key={i}>{b.text}</p>;
          case "heading":
            return <h2 key={i}>{b.text}</h2>;
          case "quote":
            return <blockquote key={i}>{b.text}</blockquote>;
          case "list":
            return (
              <ul key={i}>
                {(b.items || []).map((it, j) => (
                  <li key={j}>{it}</li>
                ))}
              </ul>
            );
          case "image":
            return (
              <figure key={i}>
                <img src={newsImageUrl(b.url)} alt={b.caption || ""} loading="lazy" />
                {b.caption ? <figcaption>{b.caption}</figcaption> : null}
              </figure>
            );
          default:
            return null;
        }
      })}
    </div>
  );
}
